import styled from "@emotion/styled";
import * as React from "react";

interface IProps {
  isVisible: boolean;
  xPosition: number;
  yPosition: number;
  children: React.ReactNode;
  onContentMouseEnter?: () => void;
  onContentMouseLeave?: () => void;
  contentRef: React.RefObject<HTMLDivElement>;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface StyledTooltipContentProps {
  isVisible: boolean;
  xPosition: number;
  yPosition: number;
}

const StyledTooltipContent = styled.div<StyledTooltipContentProps>`
  position: fixed;
  top: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => `${props.yPosition}px`
  };
  left: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => `${props.xPosition}px`
  };
  visibility: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "visible" : "hidden")
  };
  opacity: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? 1 : 0)
  };
`;

const StyledTooltipBox = styled.div`
  position: relative;
`;

export const TooltipContent: React.FC<IProps> = ({
  isVisible,
  xPosition,
  yPosition,
  contentRef,
  onContentMouseEnter,
  onContentMouseLeave,
  children,
}) => (
  <StyledTooltipContent
    onMouseEnter={onContentMouseEnter}
    onMouseLeave={onContentMouseLeave}
    ref={contentRef}
    isVisible={isVisible}
    xPosition={xPosition}
    yPosition={yPosition}
  >
    <StyledTooltipBox>{children}</StyledTooltipBox>
  </StyledTooltipContent>
);
